import * as Yup from "yup";

export const ChallengeThemeCategorySchema = Yup.object().shape({
  title_en: Yup.string().required(
    "Please provide the theme category's title in English"
  ),
  title_fr: Yup.string().required(
    "Please provide the theme category's title in French"
  ),
  description_en: Yup.string().required(
    "Provide the theme category's description in English"
  ),
  description_fr: Yup.string().required(
    "Provide the theme category's description in French"
  ),
});
export const ChallengeThemeSchema = Yup.object().shape({
  title_en: Yup.string().required(
    "Please provide the challenge theme's title in english"
  ),
  title_fr: Yup.string().required(
    "Please provide the challenge theme's title in french"
  ),
  description_en: Yup.string().required(
    "Provide the challenge theme's description in english"
  ),
  description_fr: Yup.string().required(
    "Provide the challenge theme's description in french"
  ),
});
export const ChallengeThemeQuestionsSchema = Yup.object().shape({
  type: Yup.string().required(
    "Please provide the challenge theme question's type"
  ),
  difficulty: Yup.string().required(
    "Please provide the challenge theme question's difficulty level"
  ),
});
export const challengeSchema = Yup.object().shape({
  title: Yup.string()
    .required("Please provide the challenge's title.")
    .min(3, "The challenge's title must have at least 3 caractors."),
  description: Yup.string().required("Provide the challenge's description."),
  starting_dates: Yup.string().required("Provide the challenge starting date."),
  ending_dates: Yup.string().required("Provide the challenge ending date."),
});
